import React, { useEffect, useState } from 'react';

import CompanyAccountCreateTable from '@components/common/Table/CompanyAccountCreateTable';
import { CustomButton } from '@components/Styles/ButtonStyle';
import { CustomStack } from '@components/Styles/CommonStyle';
import api from '@api/axios';
import { useNavigate } from 'react-router-dom';
import { useDialog } from '@context/DialogContext';

const CompanyAccountCreate = () => {
  const navigate = useNavigate();
  const { showDialog } = useDialog();
  // 법인사업자 ID
  const id = new URLSearchParams(window.location.search).get('id') || null;

  // 사업자 정보
  const [param, setParam] = useState({
    companyName: '',
    companyBusinessNumber: '',
    representative: '',
    phone: '',
    zonecode: '',
    address: '',
    detailAddress: '',
    businessLicenseFile: null,
    bankbookFile: null,
    email: '',
    bank: '',
    accountNumber: '',
  });

  // 연락처 목록
  const [contactList, setContactList] = useState([]);

  // 연락처 정보
  const [contactParam, setContactParam] = useState({ name: '', duty: '', phone: '', mobile: '', email: '' });

  // 저장
  const handleSave = () => {
    if (param.companyName === '') {
      showDialog({ title: '확인', message: '업체명을 입력해 주세요.' });
      return;
    }
    if (param.address === '') {
      showDialog({ title: '확인', message: '주소를 입력해 주세요.' });
      return;
    }

    const businessLicenseFile = param.businessLicenseFile;
    const bankbookFile = param.bankbookFile;
    const formData = new FormData();
    formData.append('license', businessLicenseFile);
    formData.append('bankbook', bankbookFile);
    formData.append('param', JSON.stringify(param));
    formData.append('contactList', JSON.stringify(contactList));

    // 신규 시 신규 업체 등록, 수정 시 수정
    let url = null;
    if (id) url = `/api/account/updateCompanyAccount?id=${id}`;
    else url = '/api/account/createCompanyAccount';

    api.post(url, formData).then((res) => {
      console.log('res');
      console.log(res);

      // 저장 성공 시 목록 페이지로 이동
      if (res.status === 200) navigate('/account/companyAccountList');
    })
      .catch((err) => {
      showDialog({ title: '', message: '이미 존재하는 업체입니다.', modalType: 'alert' });
      console.log('handleSave :: err');
      console.log(err);
    });
  };

  // 취소
  const handleCancel = () => {
    navigate('/account/companyAccountList');
  };

  useEffect(() => {
    if (id) {
      // 수정 시에 아이디에 맞는 데이터 조회
      api.get(`/api/account/readAccount?id=${id}`).then((res) => {
        console.log('res');
        console.log(res);

        if (res.status === 200) {
          const account = res?.data?.result?.account?.[0];
          const staffList = res?.data?.result?.staffList;
          const tempParam = {
            companyName: account?.company_name,
            companyBusinessNumber: account?.business_no,
            representative: account?.ceo_name,
            phone: account?.company_tel,
            zonecode: account?.zipcode,
            address: account?.address1,
            detailAddress: account?.address2,
            businessLicenseFile: account?.business_cert_url,
            bankbookFile: account?.bankbook_url,
            email: account?.invoice_email,
            bank: account?.account_bank_name,
            accountNumber: account?.account_bank_no,
          };
          const tempContactList = staffList?.map((staff) => {
            return {
              name: staff?.person_name,
              duty: staff?.duty,
              phone: staff?.tel,
              mobile: staff?.mobile,
              email: staff?.email,
              id: staff?.id
            };
          });

          // 파라미터 설정
          setParam(tempParam);
          setContactList(tempContactList);
        }
      });
    }
  }, [id]);

  return (
    <React.Fragment>
      <CompanyAccountCreateTable
        param={param}
        setParam={setParam}
        contactList={contactList}
        setContactList={setContactList}
        contactParam={contactParam}
        setContactParam={setContactParam}
      />
      <CustomStack justifyContent="center" mt={4}>
        <CustomButton color="gray" onClick={handleCancel}>
          취소
        </CustomButton>
        <CustomButton onClick={handleSave}>저장</CustomButton>
      </CustomStack>
    </React.Fragment>
  );
};

export default CompanyAccountCreate;
